
webpack.register(
    'components/image-generic/image-generic',
    function() {
        return import('components/image-generic/image-generic');
    },
    true
);